<template>
  <div
    id="custom-pagination"
    class="select-none"
    :class="{ hidden2: !totalPages }"
  >
    <div class="content">
      <vs-button
        :disabled="isWorking || currentPage === 1"
        @click="callback(currentPage - 1)"
        class="px-2 py-1"
      >
        &lt;
      </vs-button>
      <vs-button
        :disabled="isWorking || currentPage === 1"
        @click="callback(1)"
        class="px-2 py-1"
      >
        &lt;&lt;
      </vs-button>

      <vs-button
        v-for="(n, $index) in getPages"
        @click="callback(n)"
        :key="$index"
        class="px-2 py-1"
        :class="{ active: currentPage === n }"
        :disabled="isWorking || currentPage === n"
      >
        {{ n }}
      </vs-button>
      <vs-button
        :disabled="isWorking || getLastPage === currentPage"
        @click="callback(getLastPage)"
        class="px-2 py-1"
      >
        &gt;&gt;
      </vs-button>
      <vs-button
        :disabled="isWorking || getLastPage === currentPage"
        @click="callback(currentPage + 1)"
        class="px-2 py-1"
      >
        &gt;
      </vs-button>
      <vs-button class="px-2 py-1 container-total" v-if="totalContacts">
        N&deg; Contatos {{ totalContacts }}
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    totalPages: { required: true },
    currentPage: { required: true },
    isWorking: { required: true },
    onPageChange: { required: true },
    totalContacts: { required: true },
    source: { require: false },
  },
  computed: {
    getLastPage() {
      return this.totalPages;
    },
    getAllPages() {
      const pagination = [];

      for (let index = 1; index <= this.totalPages; index++) {
        pagination.push(index);
      }

      return pagination;
    },
    getPages() {
      if (this.totalPages <= 6) {
        return this.getAllPages;
      }

      let index = this.currentPage - 2;
      let increaseLimit = false;
      if (index < 1) {
        increaseLimit = true;
        index = 1;
      }

      let limit = this.currentPage + 2;
      if (increaseLimit) {
        limit = 6 - index;
      } else if (limit + 1 > this.totalPages) {
        limit = this.totalPages;
        index -= 2;
        if (limit - index > 4) {
          index = limit - 4;
        }
      }

      const pagination = [];
      for (index; index <= limit; index++) {
        pagination.push(index);
      }

      return pagination;
    },
  },
  methods: {
    callback(page) {
      if (this.onPageChange) {
        this.onPageChange(page);
      }
    },
  },
};
</script>

<style lang="scss">
#custom-pagination {
  width: 100%;
  position: relative;
  margin: auto;
  .content {
    width: auto;
    display: table;
    margin: auto;
    @media screen and (max-width: 399px) {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }
  }
  z-index: 32000;
  .vs-button {
    + .vs-button {
      margin-left: 4px;
    }
    &.active {
      background-color: var(--light-blue) !important;
    }
  }
}

@media screen and (max-width: 640px) {
  #custom-pagination {
    margin: auto -6px;
    width: 94vw;
  }
}

.container-total {
  pointer-events: none;
  margin-left: 20px !important;
  @media screen and (max-width: 393px) {
    margin-top: 20px;
    margin-left: 0 !important;
  }
  @media screen and (max-width: 418px) {
    margin-top: 20px;
    margin-left: 3px !important;
  }
}
</style>
